import * as tslib_1 from "tslib";
import { all, takeEvery, select, put, call, takeLatest, } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { moveNext, movePrev, setCurrentItem, setCurrentStreamAndItem, exitDuperbrowse, openDuperbrowse, shutdownDuperbrowse, exitDuperbrowseDone, loadDuperbrowseItem, loadDuperbrowse, openDuperbrowsePreload, unloadDuperbrowseItem, exitDuperbrowseResorationTimeout, } from './actionCreators';
import { getNextItem, getPrevItem, getIsValidStreamItem, getCurrentStreamId, getCurrentItem, getRootLocation, getCurrentStreamSchema, } from './selectors';
import { getStreamItemId, getStreamItemUrl, isDeviationStream, } from './helpers';
import { duperbrowseHistoryChanged } from '../../redux/routing/actions';
import history from '../../redux/routing/history';
import { createLocation } from 'history';
import { handleLoading } from './loader';
import ddt from '@wix/da-ddt';
import { normalize } from 'normalizr';
import { deviationListSchema } from '../../redux/normalizr/schemas/deviation';
var logger = ddt.createLogger('duperbrowse');
function getNonDuperHistoryState() {
    var _a = history.location.state || {}, duperbrowseState = _a.duperbrowseState, duperbrowseRoot = _a.duperbrowseRoot, restState = tslib_1.__rest(_a, ["duperbrowseState", "duperbrowseRoot"]);
    return restState;
}
function updateHistoryWith(item) {
    var streamId, url, itemId, state, newLocation;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentStreamId)];
            case 1:
                streamId = _a.sent();
                url = getStreamItemUrl(item);
                itemId = getStreamItemId(item);
                if (!streamId || !url || !itemId) {
                    return [2 /*return*/];
                }
                state = {
                    duperbrowseState: {
                        streamId: streamId,
                        itemId: itemId,
                    },
                };
                newLocation = createLocation(url, state, undefined, history.location);
                history.push(newLocation);
                return [2 /*return*/];
        }
    });
}
export function handleMoveNext() {
    var currentItem, nextItem, schema;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentItem)];
            case 1:
                currentItem = _a.sent();
                return [4 /*yield*/, select(getNextItem)];
            case 2:
                nextItem = _a.sent();
                return [4 /*yield*/, select(getCurrentStreamSchema)];
            case 3:
                schema = _a.sent();
                if (!nextItem) {
                    // TODO: this is where we would trigger fetch more
                    return [2 /*return*/];
                }
                logger.log('Moving to next item', nextItem);
                return [4 /*yield*/, all([
                        put(unloadDuperbrowseItem(currentItem)),
                        put(setCurrentItem(getStreamItemId(nextItem))),
                        call(updateHistoryWith, nextItem),
                        put(loadDuperbrowseItem(getStreamItemId(nextItem), schema, 'next')),
                    ])];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function handleMovePrev() {
    var currentItem, prevItem, schema;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentItem)];
            case 1:
                currentItem = _a.sent();
                return [4 /*yield*/, select(getPrevItem)];
            case 2:
                prevItem = _a.sent();
                return [4 /*yield*/, select(getCurrentStreamSchema)];
            case 3:
                schema = _a.sent();
                if (!prevItem) {
                    return [2 /*return*/];
                }
                logger.log('Moving to prev item');
                return [4 /*yield*/, all([
                        put(unloadDuperbrowseItem(currentItem)),
                        put(setCurrentItem(getStreamItemId(prevItem))),
                        call(updateHistoryWith, prevItem),
                        put(loadDuperbrowseItem(getStreamItemId(prevItem), schema, 'prev')),
                    ])];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleHistoryChange(_a) {
    var _b, streamId, itemId, isValid;
    var _c = _a.payload, location = _c.location, action = _c.action;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                // we only need to handle popstates
                if (action !== 'POP') {
                    return [2 /*return*/];
                }
                // if there is no state, bail
                if (!location.state) {
                    window.location.reload();
                    return [2 /*return*/];
                }
                if (!(location.state.duperbrowseRoot === true)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(shutdownDuperbrowse())];
            case 1:
                _d.sent();
                // clean up
                history.replace(tslib_1.__assign({}, history.location, { state: getNonDuperHistoryState() }));
                return [4 /*yield*/, put(exitDuperbrowseDone())];
            case 2:
                _d.sent();
                return [2 /*return*/];
            case 3:
                // if there is no non-root state, bail
                if (!location.state.duperbrowseState) {
                    window.location.reload();
                    return [2 /*return*/];
                }
                _b = location.state.duperbrowseState, streamId = _b.streamId, itemId = _b.itemId;
                return [4 /*yield*/, select(getIsValidStreamItem, streamId, itemId)];
            case 4:
                isValid = _d.sent();
                if (!isValid) {
                    window.location.reload();
                }
                return [4 /*yield*/, put(setCurrentStreamAndItem(streamId, itemId))];
            case 5:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
function handleLoadDuperbrowse(_a) {
    var _b, result, entities;
    var _c = _a.payload, itemId = _c.itemId, stream = _c.stream;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!isDeviationStream(stream)) return [3 /*break*/, 2];
                _b = normalize(stream.items, deviationListSchema), result = _b.result, entities = _b.entities;
                return [4 /*yield*/, put(openDuperbrowsePreload(itemId, tslib_1.__assign({}, stream, { items: result, itemSchema: 'deviation' }), entities))];
            case 1:
                _d.sent();
                return [2 /*return*/];
            case 2: return [4 /*yield*/, put(openDuperbrowse(itemId, stream))];
            case 3:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
function handleOpenDuperbrowse(_a) {
    var currentItem, isRoot;
    var _b = _a.payload, currentOpenItem = _b.currentOpenItem, itemSchema = _b.itemSchema;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getCurrentItem)];
            case 1:
                currentItem = _c.sent();
                if (!currentItem) {
                    return [2 /*return*/];
                }
                logger.log('Opening duperbrowse', currentItem);
                isRoot = !(history.location.state && history.location.state.duperbrowseState);
                if (isRoot) {
                    history.replace(tslib_1.__assign({}, history.location, { state: tslib_1.__assign({}, getNonDuperHistoryState(), { duperbrowseRoot: true }) }));
                }
                return [4 /*yield*/, all([
                        call(updateHistoryWith, currentItem),
                        put(loadDuperbrowseItem(currentOpenItem, itemSchema, undefined)),
                    ])];
            case 2:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleExitDuperbrowse() {
    var currentItem, rootLocation;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentItem)];
            case 1:
                currentItem = _a.sent();
                if (!!currentItem) return [3 /*break*/, 4];
                return [4 /*yield*/, select(getRootLocation)];
            case 2:
                rootLocation = _a.sent();
                if (rootLocation) {
                    history.push(rootLocation);
                }
                return [4 /*yield*/, put(exitDuperbrowseDone())];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, call(updateHistoryWith, currentItem)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// We removed the lastViewedItem after a timeout so
// we avoid any problems with scroll restoration if the component
// re-renders. This comes at cost of re-render :(
function handleExitDuperbrowseDone() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(delay, 500)];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(exitDuperbrowseResorationTimeout())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function rootSaga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(moveNext, handleMoveNext),
                    takeEvery(movePrev, handleMovePrev),
                    takeEvery(duperbrowseHistoryChanged, handleHistoryChange),
                    takeEvery(loadDuperbrowse, handleLoadDuperbrowse),
                    takeEvery(openDuperbrowse, handleOpenDuperbrowse),
                    takeEvery(exitDuperbrowse, handleExitDuperbrowse),
                    takeLatest(loadDuperbrowseItem, handleLoading),
                    takeLatest(exitDuperbrowseDone, handleExitDuperbrowseDone),
                    takeLatest(shutdownDuperbrowse, handleExitDuperbrowseDone),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map